const LinearProgressBar = ({ isVisible = false, className = "" }) => {
  if (!isVisible) return null;

  return (
    <div className={`fixed top-0 left-0 right-0 z-50 ${className}`}>
      <div className="h-[0.30rem] bg-gray-100/50">
        <div
          className="h-full bg-gradient-to-r from-primary-500 to-primary-600 shadow-sm"
          style={{
            width: "30%",
            animation: "linearProgress 1.8s cubic-bezier(0.23, 1, 0.32, 1) infinite",
          }}
        />
      </div>
      <style jsx="true">{`
        @keyframes linearProgress {
          0% {
            transform: translateX(-100%);
            opacity: 0;
          }
          50% {
            opacity: 1;
          }
          100% {
            transform: translateX(400%);
            opacity: 0;
          }
        }
      `}</style>
    </div>
  );
};

const LinearLoadingOverlay = ({ isVisible = false, message = "", className = "" }) => {
  if (!isVisible) return null;

  return (
    <div
      className={`absolute inset-0 bg-white/40 backdrop-blur-[2px] flex items-center justify-center z-[9999] transition-all duration-300 ease-out ${className} pointer-events-none rounded-md`}
      style={{
        animation: "fadeIn 0.2s cubic-bezier(0.23, 1, 0.32, 1)",
      }}
    >
      {message && (
        <div className="flex flex-col items-center gap-2 px-3 py-2 bg-white/95 rounded-lg shadow-lg border border-gray-200/50 backdrop-blur-sm">
          <div className="w-4 h-4">
            <div
              className={`w-full h-full border-2 border-gray-200 border-t-primary-600 rounded-full`}
              style={{
                animation: "spin 0.8s cubic-bezier(0.4, 0, 0.2, 1) infinite",
              }}
            />
            <style jsx="true">{`
              @keyframes spin {
                to {
                  transform: rotate(360deg);
                }
              }
            `}</style>
          </div>
          <span className="text-xs text-gray-700 font-medium tracking-wide">{message}</span>
        </div>
      )}
      <style jsx="true">{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
      `}</style>
    </div>
  );
};

export { LinearProgressBar, LinearLoadingOverlay };
